import { useLayoutEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import classNames from "classnames";
import "./styles.scss";

export const StepBars = ({
  stepCount,
  currentStep,
  title,
  description,
}: {
  stepCount: number;
  currentStep: number;
  title?: string;
  description?: string | false;
}) => {
  const [rendered, setRendered] = useState(false);

  useLayoutEffect(() => {
    if (!rendered) {
      setRendered(true);
    }
  }, [rendered]);

  const maxWidth = `${100 / stepCount}%`;

  const stepBars = Array.from({ length: stepCount }, (_, i) => {
    return (
      <div
        key={i}
        style={{ maxWidth }}
        className={`step-bar ${i < currentStep ? "active" : ""}`}
      >
        <div className="step-bar-background">
          <div
            style={{ maxWidth: "100%" }}
            className={classNames(
              "inner-bar",
              rendered && i + 1 <= currentStep && "active"
            )}
          />
        </div>
      </div>
    );
  });

  return (
    <div className="step-bars-container">
      {title && (
        <Typography
          variant={"display3" as any}
          component="h3"
          fontSize={{
            xs: "24px !important",
            sm: "32px !important",
          }}
          className="step-bars-title margin-top-0"
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          variant="body1"
          className="step-bars-description font-size-4"
        >
          {description}
        </Typography>
      )}
      <Stack direction="row" gap={2}>
        {stepBars}
      </Stack>
      <div className="step-count-container">
        <Typography variant="caption" className="step-count font-size-3">
          {currentStep} of {stepCount}
        </Typography>
      </div>
    </div>
  );
};
